import { render } from "./AddressDetails.vue?vue&type=template&id=6ec189bf&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"

import "./AddressDetails.vue?vue&type=style&index=0&id=6ec189bf&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec189bf"]])

export default __exports__